/* eslint-disable arrow-body-style */
import { Box } from '@chakra-ui/react';

const About = () => {
  return <Box>About page goes here</Box>;
};
export default About;
